<template>
  <div class="choicePay main-panel">
    <div class="main">
      <z-steps v-if="$route.query.display !== '1'" :step="3"></z-steps>
      <div>
        <div class="payStyleTitle">
          <div
            class="payline payStyleTitleSpacil chioceTitle"
            style="padding-top: 0px;"
          >
            选择付款方式
            <span class="chioceTitle-msg">
              <i class="iconfont icon-jinggao"></i>
              开票抬头为您的汇款方抬头，请使用您需要开票的对公账号支付。
            </span>
          </div>
          <div class="msg">
            <div class="msgDetail">
              <p class="orderType">
                支付内容：
                <span v-if="orderDetail.paymentStage">{{
                  orderDetail.paymentStage
                }}</span>
                <span v-else>{{ orderDetail.subject }}</span>
                <span v-if="orderDetail.paymentStagePercent"
                  >（{{ orderDetail.paymentStagePercent }}%）</span
                >
              </p>
              <p class="orderPrice">
                应付金额：
                <span class="price">{{
                  orderDetail.amountDisplay ||
                    orderDetail.amount | currency("¥", "2")
                }}</span>
              </p>
              <p class="orderNum">
                订单号：
                <span>{{ orderDetail.code }}</span>
              </p>
            </div>
          </div>
        </div>
        <div
          class="payline payStyleTitleSpacil"
          style="padding-left:34px;padding-bottom:32px;"
        >
          <div class="payline-line">支付方式</div>
        </div>
        <div class="payline">线上支付</div>
        <div class="zhu-choice">
          <div class="choiceCom">
            <div class="item" @click="choicePayType(1)">
              <span :class="isActiveNum === 1 ? 'active' : ''"></span>
              <div class="font">
                <i class="logo-zhifubao iconfont icon-umidd17"></i>
                <i class="logo-text iconfont icon-zhifubao1"></i>
              </div>
            </div>
            <div class="item" @click="choicePayType(2)">
              <span :class="isActiveNum === 2 ? 'active' : ''"></span>
              <div class="font">
                <i class="logo-weixin iconfont icon-weixinzhifu1"></i>
                <i class="weixin-text iconfont icon-WeChatpayment"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="display ? 'paylineHidden' : ''"
        v-if="orderDetail.orderChannel == 'zhulogic'"
      >
        <div class="payline">线下支付</div>
        <div class="zhu-choice">
          <div class="choiceCom choiceComLine">
            <div class="item" style="width: 210px;" @click="choicePayType(3)">
              <span :class="isActiveNum === 3 ? 'active' : ''"></span>
              <div class="font">
                <i class="iconfont icon-card un-line-i"></i>
                <div class="un-line-text">线下汇款</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="buttonFat">
        <Row class="botom_btn" type="flex" justify="center" align="middle">
          <Col span="5">
            <Button long @click="linkHref" class="red-btn" type="primary"
              >立即支付</Button
            >
            <!-- <p style="ont-size: 14px;margin-top: 5px;">{{countdown}}</p> -->
          </Col>
        </Row>

        <span class="changeOrders" @click="changeOrders">
          <i class="iconfont icon-arrow-right"></i>
          返回
        </span>
      </div>
    </div>

    <div style="height:70px;"></div>

    <dialog-com
      :dialInfo="diaInfo"
      :orderId="chargeId"
      :typeData="type"
      @closeDialog="closeDialog"
    ></dialog-com>

  </div>
</template>

<script>
import searchBox from "../../../common/searchBox.vue";
import payTop from "./payTop.vue";
import api from "../../../../api";
import dialogCom from "./dialog.vue";
import loading from "../../../common/loading.vue";
import config from "../../../../config/config";
import pingpp from "pingpp-js";
import Pay from "../../../../mixins/pay";
export default {
  mixins: [Pay],
  data() {
    return {
      VUE_APP_NEXT_BASIC_URL: process.env.VUE_APP_NEXT_BASIC_URL,
      title: "支付方式",
      config: config,
      isActiveNum: 1,
      orderDetail: "",
      hrefPath: "#",
      isAliorWechat: 0,
      orderId: "",
      chargeId: "",
      type: "",
      diaInfo: {
        title: "确认付款",
        modal1: false,
        width: 600,
        type: 0,
        closable: false
      },
      display: this.$route.query.display === "1" ? true : false,
      validTime: "",
      countdown: "",
      timer: ""
    };
  },
  methods: {
    closeDialog() {
      this.$router.go(0);
    },

    payAjax() {
      if (this.isActiveNum === 3) {
        this.$router.push({
          name: "certificateUpload",
          params: { id: this.orderId }
        });
        return;
      }
      let channle = this.isActiveNum === 0 ? "upacp_pc" : "alipay_pc_direct";
      const data = { channel: channle, id: this.orderId, type: this.type };
      this.orderDetail.channel = channle;
      api.pay.payMent(this.orderDetail).then(res => {
        pingpp.createPayment(res, function(result, err) {
          if (err) {
            console.log(err);
          }
        });
      });
    },

    choicePayType(type) {
      this.isActiveNum = type;
      if (type === 2) {
        this.isAliorWechat = 1;
      } else {
        this.isAliorWechat = 0;
      }
    },
    linkHref() {
      var _this = this;
      if (this.isAliorWechat === 0) {
        this.payAjax();
      } else {
        const dataItme = { channel: "wx_pub_qr", data: this.orderDetail };
        this.orderDetail.channel = "wx_pub_qr";
        let newWin = window.open();
        api.pay.payMent(this.orderDetail).then(res => {
          this.url = res.url;
          this.Id = res.Id;
          this.chargeId = res.Id;
          newWin.location.href =
            process.env.VUE_APP_OLD_BASIC_URL +
            "/my/pay/wechatPay?id=" +
            this.orderId +
            "&type=" +
            this.type +
            "&weichatId=" +
            this.Id +
            "&url=" +
            this.url +
            "&orderNo=" +
            res.order_no +
            "&payChannel=wx_pub";
        });
        setTimeout(function() {
          _this.diaInfo.modal1 = true;
        }, 500);
      }
    },
    changeOrders() {
      if (this.$route.query.display && this.$route.query.display === "1") {
        history.go(-1);
      } else {
        location.href = `${this.VUE_APP_NEXT_BASIC_URL}/details/${this.$route.params.id}`;
      }
    },

    eggBuyAjax(id) {
      api.pay.recharge_info(id).then(res => {
        if (res && res.status_code && res.status_code == 301) {
          this.$router.push({
            path: "/my/pay/paySuccess/" + this.orderId + "/" + this.type
          });
        } else {
          this.orderDetail = res;
          if (this.orderDetail.orderChannel === "justeasy") {
            this.choicePayType(1);
          }
        }
      });
    },

    /* 付款倒计时 */
    showtime(validTime) {
      if (!validTime) {
        this.countdown = "";
        return false;
      }
      var nowtime = new Date();
      var lefttime = parseInt(validTime / 1000);
      var d = parseInt(lefttime / (24 * 60 * 60));
      var h = parseInt((lefttime / (60 * 60)) % 24);
      var m = parseInt((lefttime / 60) % 60);
      var s = parseInt(lefttime % 60);
      h = this.addZero(h);
      m = this.addZero(m);
      s = this.addZero(s);
      this.countdown =
        "剩余付款时间：" + `${d}` + `天` + h + "时" + m + "分" + s + "秒";
      if (lefttime <= 0) {
        this.countdown = "";
        clearInterval(this.timer);
      }
    },

    addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    createTimer(validTime) {
      this.timer = setInterval(() => {
        validTime = validTime - 1000;
        this.showtime(validTime);
      }, 1000);
    }
  },
  components: {
    searchBox,
    payTop,
    dialogCom
  },

  created() {
    const _this = this;
    this.orderId = _this.$route.params.id;
    let type = _this.$route.params.type;
    if (this.config.isMtbbs) {
      this.isActiveNum = 1;
    }
    if (type === "5") {
      this.type = "points";
    } else if (type === "4") {
      this.type = "member";
    } else {
      this.type = "orderStage";
    }
    if (this.display) {
      this.eggBuyAjax(this.orderId);
    } else {
      api.pay.payMentInfo(_this.orderId).then(res => {
        this.validTime = res.timeExpire;
        // this.createTimer(res.timeExpire);
        if (res && res.status_code && res.status_code == 301) {
          _this.$router.push({
            path: "/my/pay/paySuccess/" + this.orderId + "/" + this.type
          });
        } else {
          _this.orderDetail = res;
          if (this.orderDetail.orderChannel === "justeasy") {
            this.choicePayType(1);
          }
        }
      });
    }
  }
  // beforeDestroy() {
  //   clearInterval(this.timer);
  // }
};
</script>

<style lang="scss" scoped>
.choicePay {
  margin-top: 0;
  padding: 50px 0 50px;
}
.choicePay .choiceCom {
  width: 100%;
  min-height: 100%;
  &::after {
    content: "";
    display: block;
    clear: both;
  }
}
.choicePay .choiceComLine {
  border: none;
}
.choicePay .main {
  width: 1200px;
  margin: 0px auto;
  margin-bottom: 0;
}
.choicePay .msg .title {
  font-size: 28px;
  color: #308697;
}
.choicePay .msg .msgDetail {
  width: 100%;
  height: 20px;
  margin: 10px 0;
}
.choicePay .msg .msgDetail p {
  color: #353838;
  font-size: 16px;
}
.choicePay .msg .msgDetail .orderNum {
  color: #868686;
  font-size: 16px;
}
.choicePay .msg .msgDetail .orderNum span {
  color: #313131;
}
.choicePay .msg .msgDetail .orderType {
  margin: 15px 0;
  color: #707070;
  font-size: 16px;
}
.choicePay .msg .msgDetail .orderType span {
  color: #313131;
}
.choicePay .msg .msgDetail .orderPrice {
  margin-bottom: 15px;
  color: #707070;
}
.choicePay .msg .msgDetail .orderPrice .price {
  font-size: 24px;
  color: #e14b5d;
  line-height: 20px;
}

.payStyleTitle {
  background: #ffffff;
  width: 100%;
  padding: 30px 34px 100px 34px;
  font-size: 20px;
  color: #21201f;
  margin-top: 30px;
  margin-bottom: 30px;
}

.paylineHidden {
  display: none;
}
.payline {
  background: #ffffff;
  width: 100%;
  padding: 0px 34px;
  font-size: 16px;
  color: #21201f;
}
.payStyleTitleSpacil {
  padding-left: 0px;
  font-size: 18px;
  padding-top: 25px;
}
.payStyleTitleSpacil .payline-line {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 15px;
  font-weight: 500;
}
.chioceTitle {
  padding-bottom: 10px;
  border-bottom: 1px solid #e7e7e7;
  font-weight: 500;
}
.chioceTitle-msg {
  color: #eb5757;
  display: inline-block;
  margin-left: 10px;
  vertical-align: middle;
  font-size: 12px;
}
.chioceTitle-msg i {
  vertical-align: middle;
  font-size: 20px;
}

.choicePay .zhu-choice {
  height: 145px;
  width: 100%;
  padding: 0 90px;
  background: #fff;
  padding-bottom: 35px;
  padding-top: 15px;
}
.choicePay .zhu-choice .item {
  width: 200px;
  cursor: pointer;
  line-height: 36px;
  float: left;
  margin-right: 30px;
  margin-top: 35px;
}
.choicePay .zhu-choice .item div {
  line-height: inherit;
}
.choicePay .zhu-choice .item:first-child {
  margin-right: 65px;
}
.choicePay .zhu-choice .item span {
  float: left;
  height: 20px;
  margin-top: 8px;
  margin-right: 20px;
  border: 2px solid #a2a2a8;
  width: 20px;
  border-radius: 50%;
}
.choicePay .zhu-choice .item .active {
  background: #e56a69;
  /*opacity: 1;*/
  border: none;
  transition: background 0.5s;
  -moz-transition: background 0.5s;
  -webkit-transition: background 0.5s;
  -o-transition: background 0.5s;
}
.choicePay .zhu-choice .item .font i {
  font-size: 40px;
}
.choicePay .zhu-choice .item .font .logo-zhifubao {
  color: #25abee;
}
.choicePay .zhu-choice .item .font .logo-text {
  color: #394144;
}
.choicePay .zhu-choice .item .font .logo-weixin {
  color: #00b700;
}
.choicePay .zhu-choice .item .font .weixin-text {
  font-size: 20px;
  color: #394144;
  margin-right: 28px;
  float: right;
}
.choicePay .main .buttonFat {
  width: 100%;
  background: #fff;
  height: 80px;
  float: left;
  margin-top: -5px;
}
.choicePay .main .buttonFat .changeOrders {
  float: left;
  margin-top: -15px;
  font-size: 14px;
  color: #313131;
  margin-left: 34px;
  cursor: pointer;
  text-decoration: underline;
}
.choicePay .main .buttonFat .changeOrders i {
  font-size: 12px;
}
.choicePay .main .button {
  width: 145px;
  height: 40px;
  background: #99c72c;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  margin-top: 5px;
  margin-right: 34px;
  float: right;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.choicePay .main .button:hover {
  opacity: 0.8;
}
.un-line-i {
  color: #f9c63c;
  font-size: 35px !important;
}
.un-line-text {
  display: inline-block;
  vertical-align: text-bottom;
  margin-left: 10px;
  font-size: 21px;
}
</style>
<style lang="scss">
.main-panel {
  margin-top: -10px;
  .zSteps {
    background: transparent;
  }
  .zSteps-common .col-span {
    background: #313131;
  }
  .zSteps-line .line {
    width: 0px !important;
  }
}
</style>
